import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["content"]
const _hoisted_2 = ["content"]

import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { APP_NAME } from '../../util'
import { usePageHeadStore } from '../store'


export default /*@__PURE__*/_defineComponent({
  __name: 'PageHead',
  setup(__props) {

const { t } = useI18n()
const { head } = storeToRefs(usePageHeadStore())

const page = computed(() => {
  const { title, titleKey, titleParams } = head.value
  if (title) return title
  return titleKey ? t(titleKey, titleParams ?? {}) : undefined
})

const title = computed(() => (page.value ? `${page.value} · ${APP_NAME}` : APP_NAME))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
    _createElementVNode("title", null, _toDisplayString(title.value), 1 /* TEXT */),
    (_unref(head).description)
      ? (_openBlock(), _createElementBlock("meta", {
          key: 0,
          name: "description",
          content: _unref(head).description
        }, null, 8 /* PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true),
    (_unref(head).robots)
      ? (_openBlock(), _createElementBlock("meta", {
          key: 1,
          name: "robots",
          content: _unref(head).robots
        }, null, 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})